import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FavoriteFilledIcon = function FavoriteFilledIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FavoriteFilledIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.64 1.891a.719.719 0 0 0-1.28 0L5.586 5.369l-3.97.563a.72.72 0 0 0-.583.488.71.71 0 0 0 .19.733l2.861 2.7-.674 3.811a.71.71 0 0 0 .28.697c.22.16.512.184.755.06L8 12.611l3.554 1.81c.243.124.535.1.754-.06a.71.71 0 0 0 .281-.697l-.674-3.81 2.862-2.701a.71.71 0 0 0 .189-.733.72.72 0 0 0-.582-.488l-3.971-.563z",
      clipRule: "evenodd"
    })
  }));
};

export { FavoriteFilledIcon };
